export const store = {
  email: 'contato@lojaricatanto.com.br',
  whatsapp: 'https://wa.me/551123668535',
  phone: '(11) 2366-8535',
  cnpj: '48.164.179/0002-20',
  legalName: 'DNS VENDAS E SERVICOS INTEGRADOS',
};
